import type { Player } from "@/types/app/Player";

const getPlayerNameById = (players: Player[], id: number): string => {
	const player = players.find((p) => p.id === id);
	return player ? `${player.name} ${player.surname}` : "VOLNO";
};

const getFullPlayerName = (player?: Player): string | null => {
	return !player ? null : `${player.name} ${player.surname}`;
};

export { getFullPlayerName, getPlayerNameById };
